// extracted by mini-css-extract-plugin
module.exports = {"adSection":"_F","ad":"_G","borderTop":"_H","borderBottom":"_I","adBlock":"_J"};